<template>
  <v-card>
    <v-card-title
      v-ripple
      class="py-2 px-4 pointer"
    >
      <div class="py-2">
        <h4>{{ $t('Coupon') }}</h4>
      </div>
      <v-spacer/>
    </v-card-title>

    <v-divider/>

    <v-card-text
      class="py-2"
    >
      <v-layout>
        <v-flex
          lg8
          class="pointer"
          @click="setCoupon"
        >
          <v-chip
            v-if="order.coupon"
            :color="order.applied_coupon ? 'green' : 'error'"
            class="mt-2"
            text-color="white"
          >
            <v-avatar>
              <v-icon v-if="order.applied_coupon">check_circle</v-icon>
              <v-icon v-else>cancel</v-icon>
            </v-avatar>
            {{ order.coupon }}
          </v-chip>
          <div
            v-else
            class="px-2 py-3 text--disabled">{{ $t('No Coupon') }}</div>
        </v-flex>
        <v-flex
          lg4
          class="text-xs-right">
          <v-btn
            v-if="order.id"
            icon
            flat
            class="text--disabled"
            @click="setCoupon"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-if="order.id"
            :disabled="!order.coupon"
            icon
            flat
            class="text--disabled"
            @click="$emit('remove-coupon')"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'OrderDraftCoupon',

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  methods: {
    setCoupon () {
      this.$emit('set-coupon')
    }
  }
}
</script>
